import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "panel" }

import { ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { getValueInUserLanguage } from '@/core/languageContent';
import PageLayout from '@/core/components/PageLayout.vue';
import ResourceTable from '@/core/components/resource/ResourceTable.vue';
import Column from '@/core/components/resource/Column';
import ActionColumn from '@/core/components/resource/ActionColumn';
import { TicketCategory, useTicketCategory } from '@/modules/ticket_category/TicketCategory';


export default /*@__PURE__*/_defineComponent({
  __name: 'TicketCategoryIndex',
  setup(__props) {

const { $gettext } = useGettext();
const resource = useTicketCategory();
const ticketCategoryToDelete = ref<TicketCategory>();
const deleteName = () => {
	if (!ticketCategoryToDelete.value) {
		return '';
	}

	return getValueInUserLanguage(ticketCategoryToDelete.value?.content);
};

const columns = [
	new Column<TicketCategory>($gettext('Namn'), 'content', 'name', '+')
		.withFormatter(row => getValueInUserLanguage(row.content) as string),
	new ActionColumn<TicketCategory>()
		.withEditLink((tc) => ({ name: 'ticket_category.edit', params: { id: tc.id } }))
		.withDeleteLink((tc: TicketCategory) => {
			ticketCategoryToDelete.value = tc;
		}),
];

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": _unref($gettext)('Ärendekategorier')
  }, {
    "header-actions": _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
        to: {name: 'ticket_category.create'},
        class: "button"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Ny kategori ", -1)
        ]))]),
        _: 1
      })), [
        [_directive_translate]
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ResourceTable, {
          resource: _unref(resource),
          columns: columns,
          "delete-title": _unref($gettext)('Ta bort kategori'),
          "delete-name-key": deleteName,
          "to-delete": ticketCategoryToDelete.value,
          "onUpdate:toDelete": _cache[0] || (_cache[0] = ($event: any) => ((ticketCategoryToDelete).value = $event))
        }, null, 8, ["resource", "delete-title", "to-delete"])
      ])
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})